export default function StatusMessageController($scope, $state, $timeout) {

	$scope.item = $scope.object.item;
	$scope.key = $scope.object.timestamp;

	$scope.close = function (key, list) {
		for (var i = 0; i < list.length; i++) {
			if (list[i].timestamp == key) {
				list.splice(i, 1);
				break;
			}
		}
	};

	$scope.jumpTo = function (sref) {
		$state.go(sref);
	};

	/**
	 * Automata bezárás
	 */
	// TODO: (nice to have) ha hover-ezek a notin, akkor ne zárja be
	// TODO: (nice to have) legyen sticky paraméter, ami ha true, akkro nincs automata bezárás
	// TODO: (nice to have) legyen endpointonként paraméterezhető, hogy mennyi ideig látszódjanak
	(function (key, list) {
		$timeout(function () {
			$scope.close(key, list);
		}, 3000);
	}($scope.key, $scope.statusMessages));
}
